import { useContext, useEffect, useState } from "react";
import Loader from "../../components/Shared/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { DropboxOutlined, CloudDownloadOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import CardHeader from "../../components/Shared/CardHeader";
import { Button, Radio, Select, Table } from "antd";
import { staffColumnsFull, staffColumnsFullAnnual, staffColumnsSimple, staffColumnsSimpleAnnual, StaffDownloadOptions, StaffRadioOptions } from "../../Static/StaffsStatic";
import './styles.css';
import { StaffListVO, StaffsModel } from "../../models/staffsModel";
import { toast } from "react-toastify";
import { DeleteAllStaff, DeleteStaff, DeleteStaffsMassive, DownloadStaff, GetAllByServiceId, GetAllToImportLastYear, ImportStaffs, UploadStaff } from "../../API/StaffsAPI";
import { formatDateWithNormalHour } from "../../utils/formatDate";
import { UploadModal } from "../../components/Shared/UploadModal";
import useLoading from "../../hooks/useLoading";
import useModal from "../../hooks/useModal";
import ImportStaffModal from "../../components/Staffs/ImportStaffModal";
import { ModalDeleteMassiveStaff } from "../../components/Staffs/ModalDeleteMassiveStaff";
import ModalDelete from "../../components/Shared/ModalDelete";
import { CompanyContext } from "../../contexts/companyContext";

export default function Staffs() {
    const { loading, toggleLoading } = useLoading();
    const { isShowing, toggle } = useModal();
    const { isShowing: isShowingImport, toggle: toggleImport } = useModal();
    const { isShowing: isShowingDelete, toggle: toggleDelete } = useModal();
    const [file, setFile] = useState<Blob>();
    const [selectOptionDownload, setSelectOptionDownload] = useState<string>("5");
    const [selectOptionRadio, setSelectOptionRadio] = useState<string>("0");
    const [staffs, setStaffs] = useState<StaffListVO>();
    const [allStaffsToImport, setAllStaffsToImport] = useState<StaffsModel[]>([]);
    const [isMassive, setIsMassive] = useState<boolean>(false);
    const [modalDeleteResponse, setModalDeleteResponse] = useState<boolean>(false);
    const [idToDelete, setIdToDelete] = useState<string>("");
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isMassiveModalOpen, setIsMassiveModalOpen] = useState<boolean>(false);
    const { serviceId } = useParams();
    const {company} = useContext(CompanyContext);
    const navigate = useNavigate();

    const createInteractionButtons = ({ objectData }: { objectData: { [key: string]: any } }) => {

        const { id } = objectData

        return (
            <div className="d-flex align-items-center">
                <Button onClick={() => editStaff(id)} className="btn-edit-staff" type="text" icon={<EditOutlined />} />
                <Button onClick={() => showDelete(id)} className="btn-delete-staff-solo" type="text" icon={<DeleteOutlined />} />
            </div>
        )
    }

    function handleChange(value: string) {
        setSelectOptionDownload(value);
    }

    function handleChangeRadio(value: string) {
        setSelectOptionRadio(value);
    }

    async function getAllStaffs() {
        try {
            toggleLoading(true);

            await GetAllByServiceId(serviceId ?? "").then((resp) => {
                const data = resp.data;

                
                data.staffList = (data.staffList || []).map((e: StaffsModel) => {
                    const totalCost = e.staffRubric?.totalCost ?? 0;
                    const totalHours = e.staffRubric?.totalHours ?? 0;
                    return {
                        ...e,
                        totalCost,
                        totalHours,
                        actions: createInteractionButtons({ objectData: e })
                    }
                });

                setStaffs(data);
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function download() {
        try {
            toggleLoading(true);

            await DownloadStaff(serviceId ?? "", parseInt(selectOptionDownload));
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function upload() {
        try {
            toggleLoading(true);

            await UploadStaff(file!, serviceId ?? "").then((resp) => {
                toast.success("Upload feito com sucesso!");
                toggle();
                getAllStaffs();

            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function getAllImportStaff() {
        try {
            toggleLoading(true);

            await GetAllToImportLastYear(serviceId ?? "").then((resp) => {
                setAllStaffsToImport(resp.data);
                toggleImport();
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function importStaff(staffIdList: string) {
        try {
            toggleLoading(true);

            await ImportStaffs(staffIdList, serviceId ?? "").then((resp) => {
                toast.success("Upload feito com sucesso!");
                toggleImport();
                getAllStaffs();

            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function deleteStaff() {
        try {
            toggleLoading(true);

            await DeleteStaff(serviceId ?? "", idToDelete).then((resp) => {
                toast.success("Staff deletado com sucesso!");
                getAllStaffs();
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function deleteAllStaff() {
        try {
            toggleLoading(true);

            await DeleteAllStaff(serviceId ?? "").then((resp) => {
                toast.success("Todos os Staffs foram deletados com sucesso!");
                getAllStaffs();
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    async function deleteMassiveStaffs() {
        try {
            toggleLoading(true);
            await DeleteStaffsMassive(serviceId ?? "", selectedRowKeys.map(id => id.toString()));
            toast.success("Staffs deletados com sucesso!");
            setSelectedRowKeys([]);
            getAllStaffs();
        } catch (error: any) {
            toast.error("Ocorreu um erro ao tentar deletar os staffs selecionados.");
        } finally {
            toggleLoading(false);
        }
    }

    const showMassiveDelete = () => {
        setIsMassive(true);
        setIsMassiveModalOpen(true);
    }

    const showDelete = (id: string) => {
        setIsMassive(false);
        setIdToDelete(id);
        toggleDelete();
    }

    const editStaff = (id: string) => {
        navigate(`EditStaff/${id}`);
    }

    const navigateToCreate = () => navigate('CreateStaff');

    const defaultFooter = () => `Última alteração feita por: ${staffs!.userName} ${formatDateWithNormalHour(new Date(staffs!.lastModifiedDate), true)}`;

    useEffect(() => {
        getAllStaffs();
    }, []);

    useEffect(() => {
        if (modalDeleteResponse) {
            isMassive ? deleteMassiveStaffs() : deleteStaff();
        }
    }, [modalDeleteResponse]);

    return (
        <>
            {loading && <Loader />}
            <ModalDelete
                isMassive={isMassive}
                setResponse={setModalDeleteResponse}
                show={isShowingDelete}
                toggleShow={toggleDelete}
                message={isMassive ? "Tem certeza que deseja deletar os itens selecionados?" : "Tem certeza que deseja deletar este item?"}
            />
            <ModalDeleteMassiveStaff
                isOpen={isMassiveModalOpen}
                setOpen={setIsMassiveModalOpen}
                operation={deleteMassiveStaffs}
                itemsCount={selectedRowKeys.length}
            />
            <UploadModal toggle={toggle} action={upload} isShowing={isShowing} setFile={setFile} />
            <ImportStaffModal allStaffs={allStaffsToImport} action={importStaff} handleClose={toggleImport} isShowing={isShowingImport} />
            <div className='card'>
                <CardHeader
                    pageName={"Cadastro de Funcionários"}
                    hasPageBefore={false}
                />
                <div className='card-body'>
                    <div className="d-flex align-items-center justify-content-end">
                        <Button onClick={getAllImportStaff} size="large" icon={<DropboxOutlined />}>
                            Importar Funcionários do Ano Anterior
                        </Button>

                        <div className="d-flex align-items-center">
                            <Select
                                size="large"
                                defaultValue={selectOptionDownload}
                                value={selectOptionDownload}
                                className="select-download"
                                onChange={handleChange}
                                options={StaffDownloadOptions}
                            />
                            <Button onClick={download} size="large" className="btn-download-excel" icon={<CloudDownloadOutlined />}>
                                Download Modelo
                            </Button>
                        </div>

                        <Button onClick={toggle} size="large" className="btn-upload-excel" icon={<CloudDownloadOutlined />}>
                            Upload Modelo
                        </Button>
                    </div>
                    <div className="mt-4 d-flex align-items-center justify-content-between">
                        <Radio.Group
                            block
                            size="large"
                            options={StaffRadioOptions}
                            defaultValue={selectOptionRadio}
                            value={selectOptionRadio}
                            optionType="button"
                            onChange={(e) => handleChangeRadio(e.target.value)}
                            buttonStyle="solid"
                            className="radio-table-type"
                        />

                        <div className="d-flex align-items-center">
                            <Button onClick={navigateToCreate} size="large" type="primary" className="btn-insert-excel" icon={<PlusOutlined />}>
                                Inserir Funcionário
                            </Button>
                            <Button onClick={showMassiveDelete} disabled={selectedRowKeys.length === 0} danger size="large" className="btn-delete-massive-danger" icon={<DeleteOutlined />}>
                                Deletar Massivo
                            </Button>
                        </div>
                    </div>

                    <div className="table-staff-container">
                        <Table
                            rowSelection={{
                                selectedRowKeys,
                                onChange: (keys) => setSelectedRowKeys(keys),
                            }}
                            footer={staffs && staffs.userName ? defaultFooter : () => ""}
                            scroll={{ x: 'max-content' }}
                            rowKey={record => record.id}
                            dataSource={staffs ? staffs.staffList : []}
                            columns={company.counting !== 1 ? selectOptionRadio === "0" ? staffColumnsFullAnnual : staffColumnsSimpleAnnual : selectOptionRadio === "0" ? staffColumnsFull : staffColumnsSimple}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}